export const company = {
  name: 'CoPro Services',
  tagline: 'Professional Solutions. Reliable Results.',
  location: 'Orlando, Florida',
  serviceArea: 'Serving Orlando & Central Florida',
  phoneDisplay: '(407) 436-7930',
  phoneHref: 'tel:+14074367930',
  /** Quote requests are sent here. */
  email: 'info@coproservices.com',
  emailHref: 'mailto:info@coproservices.com',
  logoUrl:
    'https://cdn.magicpatterns.com/uploads/dF3grKkpU6L23vn29z5phc/CO_PRO_SERVICES_LOGO.png',
}

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Why CoPro', href: '#why-copro' },
  { label: 'Service Area', href: '#service-area' },
  { label: 'Contact', href: '#contact' },
]

export const credibilityItems = [
  'Professional Service',
  'Personalized Attention',
  'Quality-Focused',
  'Commercial & Industrial',
]

export type Service = {
  id: string
  title: string
  description: string
  items: string[]
  image: string
  alt: string
}

export const services: Service[] = [
  {
    id: 'painting',
    title: 'Commercial & Industrial Painting',
    description:
      'Professional painting solutions for commercial properties, offices, warehouses, retail spaces, multifamily properties and industrial facilities.',
    items: [
      'Interior painting',
      'Exterior painting',
      'Commercial painting',
      'Industrial painting',
      'Surface preparation',
      'Touch-ups and repainting',
      'Property improvement painting',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/05d59f7c-ce2a-42dd-95a9-9f3a252f2cdb.jpg',
    alt: 'CoPro Services painter spraying the exterior wall of a commercial retail building in Orlando',
  },
  {
    id: 'cleaning',
    title: 'Commercial & Industrial Cleaning',
    description:
      'Reliable cleaning solutions designed for professional and high-use environments.',
    items: [
      'Commercial cleaning',
      'Industrial cleaning',
      'Offices',
      'Warehouses',
      'Common areas',
      'Property turnover cleaning',
      'Facility cleaning',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/27438d54-fed6-4e15-a204-32c1541a9135.jpg',
    alt: 'Industrial cleaning technicians scrubbing the floor of a Central Florida warehouse',
  },
  {
    id: 'facility',
    title: 'Property & Facility Services',
    description: 'Flexible support for commercial properties and facilities.',
    items: [
      'Property maintenance support',
      'Facility upkeep',
      'Property improvement projects',
      'Customized commercial solutions',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/961365f2-600d-440e-b5df-2e30dbac35d0.jpg',
    alt: 'Maintenance technicians servicing a corridor in a multifamily property',
  },
]

export const benefits = [
  {
    icon: 'users',
    title: 'Personalized Service',
    description:
      'Every project is different. We listen first and provide solutions based on your specific needs.',
  },
  {
    icon: 'shield',
    title: 'Professional Approach',
    description:
      'From the first conversation to project completion, we prioritize clear communication and professional execution.',
  },
  {
    icon: 'search',
    title: 'Attention to Detail',
    description:
      'We believe the difference is in the details and approach every space with care and precision.',
  },
  {
    icon: 'layers',
    title: 'Flexible Solutions',
    description:
      'From individual projects to ongoing property needs, our services can adapt to different commercial environments.',
  },
] as const

export const industries = [
  {
    title: 'Commercial Buildings',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/34a14790-5f42-4d07-95d3-715588e47caf.jpg',
    alt: 'Modern commercial office building served by CoPro Services in Orlando',
  },
  {
    title: 'Warehouses & Industrial Facilities',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e45e6c9b-2201-453c-a067-df450382b9d8.jpg',
    alt: 'Industrial warehouse with loading docks in Central Florida',
  },
  {
    title: 'Offices',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f82f6f90-9591-42a1-9bce-8cac4a9ca591.jpg',
    alt: 'Clean modern office interior prepared for commercial painting',
  },
  {
    title: 'Retail Spaces',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ea6b2df9-6a49-4f9b-9812-26dce6aa348b.jpg',
    alt: 'Freshly painted retail shopping center storefront',
  },
  {
    title: 'Multifamily Properties',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/18a87013-1e5a-41db-8387-b99d0b15587f.jpg',
    alt: 'Multifamily apartment community exterior in Central Florida',
  },
  {
    title: 'Property Management Companies',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/176c1507-a128-4909-ad99-6335b7bbc1e5.jpg',
    alt: 'CoPro Services supervisor reviewing project details with a crew member on site',
  },
]

export const serviceNeededOptions = [
  'Commercial & Industrial Painting',
  'Interior Painting',
  'Exterior Painting',
  'Commercial Cleaning',
  'Industrial Cleaning',
  'Property & Facility Services',
  'Something else',
]

export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/8bbd7dba-3d20-4962-9f5d-9a8dc77ad690.jpg'

export const aboutImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/176c1507-a128-4909-ad99-6335b7bbc1e5.jpg'
